// All available assessment types
export const ASSESSMENT_TYPE_OPTIONS = [
  { value: 1, label: "Name the Letter" },
  { value: 2, label: "Letter Sounds" },
  { value: 3, label: "Story Reading" },
  { value: 4, label: "Silly Words" },
  { value: 5, label: "Break up the word" },
  { value: 6, label: "Say the first Sound" },
];

// All available levels
export const ALL_LEVEL_OPTIONS = [
  { value: 0, label: "Level K" },
  { value: 1, label: "Level 1" },
  { value: 2, label: "Level 2" },
  { value: 3, label: "Level 3" },
  { value: 4, label: "Level 4" },
  { value: 5, label: "Level 5" },
  { value: 6, label: "Level 6" },
  { value: 7, label: "Level 7" },
  { value: 8, label: "Level 8" },
];
